import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'wash-dry', 'WashDry', [["path",{"d":"M3 6a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v12a3 3 0 0 1 -3 3h-12a3 3 0 0 1 -3 -3v-12"}]]);